import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import HttpService from '../../services/httpService';
import { ROLENAME } from '../../utils';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { DialogContentText } from '@material-ui/core';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
    table: {
        width: '80vw',
        textAlign: 'center'
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
    tableCellCss:{
        textAlign: 'center'
    }
}));
const MoveToMarketingApproval = (props) => {
    const buttonRef = useRef(null);
    const classes = useStyles();
    const { userDetails } = useSelector(state => state.user);
    const history = useHistory();

    const [m2mLead, setM2MLead] = useState([]);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [selectedLead, setSelectedLead] = useState({});
    const [selectedAction, setSelectedAction] = useState('');
    const [reasonForApproval, setReasonForApproval] = useState('');
    const [reasonForRejection, setReasonForRejection] = useState('');

    const getDataOnPageLoading = async ()=>{
        const result = await HttpService.getm2mleads();
        setM2MLead(result.data);
    }

    useEffect(()=>{
        getDataOnPageLoading();
    },[])

    const updateLeadInM2M = async ()=>{
        try{
            // console.log(`do action ${selectedAction} for selected lead ${selectedLead._id} reason is ${reasonForApproval}`)

            if(selectedAction == 'approve'){
                const result = await HttpService.updateM2MApproval({leadId: selectedLead._id, reason:reasonForApproval})
                setOpenConfirmationModal(false)
            }
            if(selectedAction == 'reject'){
                const result = await HttpService.updateM2Mrejection({leadId: selectedLead._id, reasonForRejection:reasonForRejection})
                setOpenConfirmationModal(false)
            }
            getDataOnPageLoading()
        }
        catch(err){
            console.log('error',err)
        }
    }

    const openModalAction = (action, lead)=>{
        try{
            setSelectedLead(lead)
            setSelectedAction(action)
            setOpenConfirmationModal(true)
        }
        catch(err){
            console.log('error',err)
        }
    }

    const downloadExcel = () => {
        const data = m2mLead.map(lead => ({
            LeadNo: lead.lead_no,
            ClientName: lead.customerId.name,
            AssignedTo: lead.assignTo.name,
            AudioFile: lead.moveToMarketingAudioFile
                ? { text: 'Download Audio', hyperlink: lead.moveToMarketingAudioFile }
                : { text: 'No Audio', hyperlink: '' }
        }));

        // Create a new workbook and add a worksheet
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data, {
            header: ["LeadNo", "ClientName", "AssignedTo", "AudioFile"]
        });

        // Adding hyperlinks to audioFile column
        ws["D1"].v = "Audio File (Click to Download)";
        data.forEach((lead, index) => {
            const cellAddress = `D${index + 2}`;
            if (lead.AudioFile.hyperlink) {
                // If there is a hyperlink, make it a clickable link
                ws[cellAddress] = {
                    t: 's',
                    v: lead.AudioFile.text,
                    l: { Target: lead.AudioFile.hyperlink }
                };
            } else {
                // If no hyperlink, just show "No Audio"
                ws[cellAddress] = { t: 's', v: lead.AudioFile.text };
            }
        });

        XLSX.utils.book_append_sheet(wb, ws, "Leads");
        const fileName = "M2M_Leads.xlsx";
        XLSX.writeFile(wb, fileName);
    };      

    const handleClick = () => {
        if (buttonRef.current) {
            downloadExcel();
        }
    };
    return (
        <div>
            <div style={{ marginBottom: 20 }}>
                <h3 style={{ textAlign: 'center' }}>
                Move To Marketing Lead Approval
                </h3>
            </div>
            <Divider />
            <div style={{ display: 'flex', marginTop: 10, marginBottom: 10 }}>
                <Button
                    ref={buttonRef}
                    onClick={handleClick}
                    variant="contained"
                    color="primary"
                    startIcon={<GetAppIcon />}
                >
                    Download Excel
                </Button>
            </div>
            <div style={{ display: 'flex', marginTop: 10, marginBottom: 20 }}>
                <Paper>
                    <TableContainer component={Paper}>
                        <Table className={classes.table} stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold', width: '5%'}}>Sl No.</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold', width: '15%'}}>Lead Name</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold', width: '15%'}}>Lead No.</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold', width: '15%'}}>Assigned To.</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold', width: '15%'}}>Audio Attachment</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: '#f0f8ff', fontWeight: 'bold', width: '30%'}}>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            {m2mLead.map((row, i) => {
                                return(
                            <TableBody className={classes.tableCellCss}>
                                <TableCell component="th" className={classes.tableCellCss}>{i+1}</TableCell>
                                <TableCell component="th" className={classes.tableCellCss}>{row?.customerId?.name || 'N/A'}</TableCell>
                                <TableCell component="th" className={classes.tableCellCss}><Link to={`/project-logs/${row?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>{row?.lead_no || 'N/A'}</Link></TableCell>
                                <TableCell component="th" className={classes.tableCellCss}>{row?.assignTo?.name || 'N/A'}</TableCell>
                                <TableCell component="th" className={classes.tableCellCss}>
                                    <Button color="primary" variant="outlined" disabled={!row.moveToMarketingAudioFile} onClick={() => window.open(row?.moveToMarketingAudioFile)}>Download</Button>
                                </TableCell>
                                <TableCell component="th" className={classes.tableCellCss}>
                                    <Button color="primary" variant="contained" onClick={() => openModalAction('approve', row)} style={{ marginLeft: 1 }}>
                                        Approve
                                    </Button>
                                    <Button color="secondary" variant="outlined" onClick={() => openModalAction('reject', row)} style={{ marginLeft: 100 }}>
                                        Reject
                                    </Button>
                                </TableCell>
                            </TableBody>
                                )})}
                        </Table>
                    </TableContainer>
                </Paper>
            </div>

            <Dialog open={openConfirmationModal} onClose={() => setOpenConfirmationModal(false)}
                aria-labelledby="form-dialog-title"
                maxWidth="sm"
                fullWidth
            >
                <DialogContentText>
                    <h3 style={{ textAlign: 'center', margin: 20 }}>Do you want to {selectedAction}</h3>
                </DialogContentText>

                <DialogContent  >
                    {selectedAction == 'approve' && 
                    <Autocomplete
                        id="combo-box-demo"
                        options={['Junk', 'Hold', 'To Be Called']}
                        getOptionLabel={(option) => option}
                        onChange={(e,v)=> setReasonForApproval(v)}
                        value={reasonForApproval}
                        style={{ width: 'auto', justifyContent: "center" }}
                        renderInput={(params) => <TextField {...params} label="Reason for Lost" variant="outlined" />}
                    />
                    }
                    {selectedAction == 'reject' && 
                        <TextField
                            id="rejection-reason-box"
                            onChange={(e,v)=> setReasonForRejection(e.target.value)}
                            value={reasonForRejection}
                            style={{ width: '500px', justifyContent: "center", marginLeft: "150px", margin:"10px" }}
                            label="Reason for Rejection"
                            // variant="Outlined"
                        />
                    }
                </DialogContent>
                <DialogActions style={{justifyContent: "center"}}>
                    <Button onClick={() => setOpenConfirmationModal(false)} color="secondary" variant='outlined'>
                        Cancel
                    </Button>
                    <Button onClick={updateLeadInM2M} disabled={(selectedAction=='approve' && (reasonForApproval=='' || reasonForApproval == null)) || (selectedAction=='reject' && (reasonForRejection=='' || reasonForRejection == null))} color="primary" variant='contained'>
                        Submit
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(MoveToMarketingApproval)